import { Component } from 'react'
import PropTypes from 'prop-types'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import InsertLinkForm from './InsertLinkForm'

const StyledCard = styled.div`
  position: relative;

  .fa-times {
    position: absolute;
    right: 0.5%;
    top: 0.2rem;
    color: #666666;
    cursor: pointer;
  }

  a {
    line-height: 2;
  }
`
const Button = styled.button`
  position: absolute;
  right: 7%;
  border: none;
  background: transparent;
`

const edit = <FontAwesome name="pencil" />

class LaunchPadLink extends Component {
  state = { showLinkInfo: false }

  onDeleteClick = async (id) => {
    this.props.deleteLink(id)
  }

  render() {
    const { updateUserLink, adminLink, registerLinkClick } = this.props
    const { id, name, url } = this.props.link
    const { showLinkInfo } = this.state

    return (
      <StyledCard>
        <a
          href={url}
          onClick={registerLinkClick}
          target="_blank"
          rel="noreferrer"
        >
          {name}
        </a>
        {!adminLink && (
          <FontAwesome
            name="times"
            onClick={this.onDeleteClick.bind(this, id)}
          />
        )}
        {!adminLink && (
          <Button
            onClick={() =>
              this.setState({ showLinkInfo: !this.state.showLinkInfo })
            }
          >
            {edit}
          </Button>
        )}
        {showLinkInfo ? (
          <div>
            <InsertLinkForm
              updateUserLink={updateUserLink}
              id={id}
              name={name}
              url={url}
            />
          </div>
        ) : null}
      </StyledCard>
    )
  }
}

LaunchPadLink.propTypes = {
  adminLink: PropTypes.bool,
  updateUserLink: PropTypes.func,
  link: PropTypes.object
}

export default LaunchPadLink
